import jApi from './jApi';

export default {
  listEmployee(req) {
    const api = jApi.generateApi();
    return api.post('user/studio/employee/list', req)
      .then(res => res);
  },

  createEmployee(req) {
    const apis = jApi.generateApi();
    return apis.post('user/employee/create', req)
      .then(res => res.data);
  },

  detailEmployee(req) {
    const apis = jApi.generateApi();
    return apis.post('user/employee/detail-pro', req)
      .then(res => res.data);
  },

  updateEmployee(req) {
    const apis = jApi.generateApi();
    return apis.post('user/studio/employee/update', req)
      .then(res => res.data);
  },

  deleteEmployee(req) {
    const apis = jApi.generateApi();
    return apis.post('user/studio/employee/delete-bulk', req)
      .then(res => res.data);
  },

  listBank(req) {
    const apis = jApi.generateApi();
    return apis.post('integration-bank/bank/employee/list', req)
      .then(res => res.data);
  },

  listCountry() {
    const apis = jApi.generateApi();
    return apis.get('company/tools/countries')
      .then(res => res.data);
  },

  detailOrganigram(req) {
    const apis = jApi.generateApi();
    return apis.post('jojoflow/organigram/detail-by-user-company', req)
      .then(res => res.data);
  },

  listTeams(req) {
    const apis = jApi.generateApi();
    return apis.post('company/setup/team/list', req)
      .then(res => res.data);
  },

  employeePosition(req) {
    const api = jApi.generateApi();
    return api.post('/jojoflow/organigram/detail-by-user-company', req)
      .then(res => res.data);
  },
};



// WEBPACK FOOTER //
// ./src/services/jApiEmployee.js